(function ($) {
    $('#MiniCart, .header-cart').on("click", function() {
      if ($('body').hasClass('minicart-right')) {
          $('body').removeClass('minicart-right');
          $('.mini-cart').removeClass('active');
      } else {
          $('body').addClass('minicart-right');
          $('.mini-cart').addClass('active');
      }
      return false;
    });

    $('.minicart-close, .canvas-overlay, #continueShopping').on("click", function() {
        $('.minicart-right').removeClass('active');
        $('.mini-cart').removeClass('active');
        $('body').removeClass('minicart-right');
        return false;
    });

    /* ===============================
      MINI CART
    =============================== */
    const selectors = {
      miniCart: '.mini-cart',
      item: '.minicart-item',
      qtyPlus: '.qty-plus',
      qtyMinus: '.qty-minus',
      remove: '.minicart-remove',
      subtotal: '.minicart-subtotal .subtotal',
      minicartCount: '.minicart-count',
      headerCount: '#CartCount',
      emptyState: '.minicart-empty',
      itemsWrapper: '.minicart-items'
    };

    let isUpdating = false;

    /* ===============================
      LOADER CONTROL
    =============================== */
    function showItemLoader(line) {
      const item = document.querySelector(`${selectors.item}[data-line="${line}"]`);
      if (!item) return;
      const loader = item.querySelector('.minicart-loader');
      if (loader) loader.classList.add('active');
    }

    function hideAllLoaders() {
      document.querySelectorAll('.minicart-loader.active')
        .forEach(loader => loader.classList.remove('active'));
    }

    const compareCache = {};
    async function ensureComparePrice(variantId, fallbackOriginalPrice) {

      if (compareCache[variantId]) {
        return compareCache[variantId];
      }

      try {
        const res = await fetch(`/variants/${variantId}.js`);
        const variant = await res.json();

        const compare = variant.compare_at_price || fallbackOriginalPrice;

        compareCache[variantId] = compare;

        return compare;

      } catch (e) {
        return fallbackOriginalPrice;
      }
    }

    async function renderMiniCartItems(cart) {
      const list = document.querySelector('.minicart-items');
      if (!list) return;

      const itemPromises = cart.items.map(async (item, index) => {
        const line = index + 1;

        const variantName =
          item.variant_title && item.variant_title !== "Default Title"
            ? item.variant_title
            : "";

        const itemTotal = item.final_line_price;
        const compareBase = await ensureComparePrice(
          item.variant_id,
          item.original_price
        );

        const compareTotal = compareBase * item.quantity;

        const compareHtml =
          compareTotal > itemTotal ? `<s class="minicart-item-compare" data-base="${compareBase}">${Shopify.formatMoney(compareTotal, theme.moneyFormat)}</s>` : "";

        return `
          <li class="minicart-item animate-in" data-line="${line}" data-key="${item.key}" data-compare="${item.variant_compare_at_price || 0}">
            <div class="minicart-item-image">
              <img src="${item.image}" alt="${item.product_title}" loading="lazy">
              <div class="minicart-loader">
                <svg class="spinner" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="20"></circle>
                </svg>
              </div>
            </div>

            <div class="minicart-item-body">
              <div class="minicart-item-top">
                <div>
                  <h2 class="minicart-item-title">${item.product_title}</h2>
                  ${variantName ? `<p class="minicart-variant">${variantName}</p>` : ""}
                </div>

                <span class="minicart-item-price">
                  ${compareHtml}
                  <span class="minicart-item-final">${Shopify.formatMoney(itemTotal, theme.moneyFormat)}</span>
                </span>
              </div>

              <div class="minicart-item-controls">
                <div class="minicart-qty">
                  <button class="qty-btn qty-minus" data-line="${line}">−</button>
                  <input type="text" value="${item.quantity}" readonly>
                  <button class="qty-btn qty-plus" data-line="${line}">+</button>
                </div>

                <button class="minicart-remove" data-line="${line}">
                  Remove
                </button>
              </div>
            </div>
          </li>
        `;
      });

      const itemsHTML = await Promise.all(itemPromises);

      list.innerHTML = itemsHTML.join('');

      const items = list.querySelectorAll('.minicart-item.animate-in');
      requestAnimationFrame(() => {
        items.forEach((item, i) => {
          setTimeout(() => {
            item.classList.add('show');
          }, i * 40);
        });
      });
    }

    /* ===============================
      UPDATE DOM FROM CART JSON
    =============================== */
    async function updateDOM(cart) {
      /* ===============================
        RESET EMPTY STATE
      =============================== */
      document.querySelectorAll('.minicart-empty').forEach(el => el.remove());

      /* ===============================
        SYNC ITEMS (RENDER / UPDATE)
      =============================== */
      const list = document.querySelector('.minicart-items');

      if (list) {
        const domItems = list.querySelectorAll('.minicart-item');

        /* re-render if count changed (add / remove item) */
        if (domItems.length !== cart.items.length) {
          await renderMiniCartItems(cart);
        }
      }

      /* ===============================
        SUBTOTAL
      =============================== */
      const subtotalEl = document.querySelector('.subtotal');
      if (subtotalEl) {
        subtotalEl.innerHTML = Shopify.formatMoney(cart.total_price, theme.moneyFormat);
      }

      /* ===============================
        COUNTERS
      =============================== */
      document.querySelectorAll(selectors.minicartCount).forEach(el => {
        el.textContent = cart.item_count;
      });

      document.querySelectorAll(selectors.headerCount).forEach(el => {
        el.textContent = cart.item_count;
      });

      /* ===============================
        ITEM / ITEMS LABEL
      =============================== */
      const labelEl = document.querySelector('.minicart-label');

      if (labelEl) {
        labelEl.textContent = cart.item_count === 1 ? 'item' : 'items';
      }

      /* ===============================
        UPDATE QTY & PRICE
      ================================ */
      cart.items.forEach((item, index) => {

        const line = index + 1;
        const el = document.querySelector(`.minicart-item[data-line="${line}"]`);
        if (!el) return;

        const qtyInput = el.querySelector('.minicart-qty input');
        const finalEl = el.querySelector('.minicart-item-final');
        const compareEl = el.querySelector('.minicart-item-compare');

        /* update quantity */
        if (qtyInput) {
          qtyInput.value = item.quantity;
        }

        /* update final price */
        if (finalEl) {
          finalEl.innerHTML = Shopify.formatMoney(
            item.final_line_price,
            theme.moneyFormat
          );
        }

        /* 🔥 update compare using ORIGINAL BASE PRICE */
        if (compareEl) {
          const baseCents = parseInt(compareEl.dataset.base || 0, 10);

          if (baseCents > 0) {
            const newTotalCents = baseCents * item.quantity;

            compareEl.innerHTML = Shopify.formatMoney(
              newTotalCents,
              theme.moneyFormat
            );
          }
        }
      });

      /* ===============================
        PROMO SAVINGS (USING HTML COMPARE)
      ================================ */
      const promoAlert = document.querySelector('.minicart-promo-alert');

      if (promoAlert) {

        let totalCompare = 0;
        let totalFinal = 0;

        document.querySelectorAll('.minicart-item-compare').forEach(el => {
          const numeric = el.textContent.replace(/[^\d.]/g, '');
          const value = parseFloat(numeric);
          if (!isNaN(value)) {
            totalCompare += value;
          }
        });

        document.querySelectorAll('.minicart-item-final').forEach(el => {
          const numeric = el.textContent.replace(/[^\d.]/g, '');
          const value = parseFloat(numeric);
          if (!isNaN(value)) {
            totalFinal += value;
          }
        });

        const savings = totalCompare - totalFinal;

        if (savings > 0) {

          const cents = Math.round(savings * 100);

          let formatted;

          // Remove .00 apenas se for inteiro
          if (cents % 100 === 0) {
            formatted = Shopify.formatMoney(
              cents,
              '£{{amount_no_decimals}}'
            );
          } else {
            formatted = Shopify.formatMoney(
              cents,
              theme.moneyFormat
            );
          }

          const bold = promoAlert.querySelector('b');
          if (bold) bold.textContent = formatted;

          promoAlert.classList.remove('hide');

        } else {
          promoAlert.classList.add('hide');
        }

      }

      /* ===============================
        DELIVERY, TOTAL & FREE SHIPPING
      =============================== */

      const freeShippingLimit = parseInt(
        document.body.dataset.freeShipping || 0,
        10
      );

      const standardShipping = parseInt(
        document.body.dataset.standardShipping || 0,
        10
      );

      const deliveryEl = document.querySelector('.delivery');
      const totalEl = document.querySelector('.total-price');
      const alertEl = document.querySelector('.minicart-shipping-alert');

      /* valores */
      const currentTotal = cart.total_price;
      const prevTotalRaw = sessionStorage.getItem('prev_cart_total');
      const prevTotal = prevTotalRaw ? parseInt(prevTotalRaw, 10) : null;

      const isFreeShipping = currentTotal >= freeShippingLimit;
      const wasFreeShipping = prevTotal !== null && prevTotal >= freeShippingLimit;
      const unlockedShown = sessionStorage.getItem('free_shipping_unlocked') === 'true';

      if (deliveryEl && totalEl) {

        if (isFreeShipping) {
          /* FREE SHIPPING */
          deliveryEl.innerHTML = '<p><strong class="free">FREE</strong> <s>'+Shopify.formatMoney(theme.standard_shipping_price, theme.moneyFormat)+'</s></p>';
          totalEl.innerHTML = Shopify.formatMoney(currentTotal, theme.moneyFormat);

          /*
            MOSTRAR "UNLOCKED" SOMENTE SE:
            - existia carrinho antes (prevTotal !== null)
            - carrinho anterior NÃO tinha free shipping
            - agora TEM free shipping
            - ainda não mostramos o aviso
          */
          if (
            prevTotal !== null &&
            prevTotal > 0 &&
            !wasFreeShipping &&
            !unlockedShown &&
            alertEl
          ) {
            alertEl.classList.remove('hide');
            alertEl.classList.add('free');
            alertEl.innerHTML = '<strong>Free UK delivery unlocked.</strong>';

            sessionStorage.setItem('free_shipping_unlocked', 'true');
          } else if (alertEl) {
            alertEl.classList.add('hide');
          }

        } else {
          /* PAID SHIPPING */
          deliveryEl.innerHTML = Shopify.formatMoney(standardShipping, theme.moneyFormat);
          totalEl.innerHTML = Shopify.formatMoney(
            currentTotal + standardShipping,
            theme.moneyFormat
          );

          const remaining = freeShippingLimit - currentTotal;

          if (alertEl) {
            alertEl.classList.remove('hide');
            alertEl.classList.remove('free');
            alertEl.innerHTML = `
              Spend <strong>${Shopify.formatMoney(remaining, theme.moneyFormat)}</strong>
              more to get <strong>FREE UK delivery</strong>.
            `;
          }

          sessionStorage.setItem('free_shipping_unlocked', 'false');
        }
      }

      /* salvar total atual */
      sessionStorage.setItem('prev_cart_total', currentTotal);


      /* ===============================
        FOOTER VISIBILITY
      =============================== */

      const footer = document.querySelector('.minicart-footer');

      if (cart.item_count === 0) {
        if (footer) footer.classList.add('hide');
        if (alertEl) alertEl.classList.add('hide');
      } else {
        if (footer) footer.classList.remove('hide');
      }


      /* ===============================
        EMPTY STATE
      =============================== */
      const wrapper = document.querySelector(selectors.itemsWrapper);
      if (cart.item_count === 0 && wrapper) {
        wrapper.innerHTML = '';
        wrapper.insertAdjacentHTML(
          'afterend',
          `<div class="minicart-empty"><p>Your bag is currently empty.</p></div>`
        );
      }
    }

    /* ===============================
      FETCH CART STATE
    =============================== */
    async function fetchCartState() {
      return fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          updateDOM(cart);
          return cart;
        });
    }

    /* ===============================
      CART UPDATE
    =============================== */
    function updateCart(line, quantity) {
      if (isUpdating) return;
      isUpdating = true;

      showItemLoader(line);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      })
        .then(() => fetchCartState())
        .finally(() => {
          hideAllLoaders();
          isUpdating = false;
        });
    }

    /* ===============================
      EVENTS
    =============================== */
    document.addEventListener('click', function (e) {

      const plus = e.target.closest(selectors.qtyPlus);
      if (plus) {
        const line = plus.dataset.line;
        const input = plus.previousElementSibling;
        updateCart(line, parseInt(input.value, 10) + 1);
        return;
      }

      const minus = e.target.closest(selectors.qtyMinus);
      if (minus) {
        const line = minus.dataset.line;
        const input = minus.nextElementSibling;
        const qty = parseInt(input.value, 10) - 1;
        if (qty > 0) updateCart(line, qty);
        return;
      }

      const remove = e.target.closest(selectors.remove);
      if (remove) {
        updateCart(remove.dataset.line, 0);
      }

    });

    /* ===============================
      SAFETY (Safari / bfcache)
    =============================== */
    window.addEventListener('pageshow', function () {
      hideAllLoaders();
      isUpdating = false;
    });


    /* ===============================
      COUNTDOWN
    ================================ */
    if (document.querySelector("#timer")) {
      var countDownHours = getCookie("countDownHours");
      var countDownMinutes = getCookie("countDownMinutes");
      var countDownSeconds = getCookie("countDownSeconds");
      
      const oneSec = 1000,
      container = document.querySelector('#timer');

      var dataHoursOriginal = container.getAttribute("data-hours");
      var dataMinutesOriginal = container.getAttribute("data-minutes");
      var dataSecondsOriginal = container.getAttribute("data-seconds");

      if (countDownHours) {
        container.setAttribute("data-hours", countDownHours);
        container.setAttribute("data-minutes", countDownMinutes);
        container.setAttribute("data-seconds", countDownSeconds);
      }

      let dataHours 	= container.dataset.hours,
          dataMinutes = container.dataset.minutes,
          dataSeconds = container.dataset.seconds,
          timerEnd 		= container.getAttribute('data-timer-end'),
          timerOnEndMsg = "data-timer-end";
      
      if (dataHours == '' || dataHours == null || dataHours == NaN) {
        dataHours = "0";
      }
      if (dataMinutes == '' || dataMinutes == null || dataMinutes == NaN) {
        dataMinutes = "0";
      }
      if (dataSeconds == '' || dataSeconds == null || dataSeconds == NaN) {
        dataSeconds = "0";
      }

      let hoursSpan = document.querySelector('span.time.hours'),
        minutesSpan = document.querySelector('span.time.minutes'),
        secondsSpan = document.querySelector('span.time.seconds'),
        max = 59,
        s = parseInt(dataSeconds) > max ? max : parseInt(dataSeconds),
        m = parseInt(dataMinutes) > max ? max : parseInt(dataMinutes),
        h = parseInt(dataHours);
      
      checkValue = (value)=>{
        if (value < 10) {
          return "0" + value;
        } else {
          return value;
        }
      }
      
      hoursSpan.textContent = checkValue(dataHours);
      minutesSpan.textContent = checkValue(dataMinutes);
      secondsSpan.textContent = checkValue(dataSeconds);
      
      timer = (sv,mv,hv)=>{
      
        s = parseInt(sv);
        m = parseInt(mv);
        h = parseInt(hv);
        
        if (s > 0) {
          return s -= 1;
        } else {
          s = max;
          if (m > 0) {
            return m -= 1;
          } else {
            m = max;
            if (h > 0) {
              return h -= 1;
            }
          }
        }
      }
      
      finished = ()=>{
        max = 0;
      	let timerEnd = container.getAttribute(timerOnEndMsg);
      	// container.setAttribute(timerOnEndMsg, 'true');
      	if (timerEnd == '' || timerEnd == null) {
          //container.textContent = "timer-end";
          container.classList.add("hide");

          document.cookie = "countDownHours="+dataHoursOriginal;
          document.cookie = "countDownMinutes="+dataMinutesOriginal;
          document.cookie = "countDownSeconds="+dataSecondsOriginal;

          window.location.reload();
      	} else {
      		container.textContent = timerEnd;
      	}
      }
      
      counter = setInterval(()=>{
        if (h == 0 && m == 0 && s == 0) {
          clearInterval(counter, finished());
        }
      
        if (s >= 0) {
          timer(s,m,h);
          hoursSpan.textContent   = checkValue(h);
          minutesSpan.textContent = checkValue(m);
          secondsSpan.textContent = checkValue(s);

          if(s != 0) {
            document.cookie = "countDownHours="+h;
            document.cookie = "countDownMinutes="+m;
            document.cookie = "countDownSeconds="+s;
          }
        }
      }, oneSec);  
    }

  
    var wishListsArr = localStorage.getItem('wishListsArr') ? JSON.parse(localStorage.getItem('wishListsArr')) : [];
    localStorage.setItem('wishListsArr', JSON.stringify(wishListsArr));
    if (wishListsArr.length) {
        wishListsArr = JSON.parse(localStorage.getItem('wishListsArr'));
    };

    var descriptionMinimized = document.querySelector('.description.minimized')

    if (descriptionMinimized) {
      var button = document.querySelector(".button-expand-text");
    
      button.addEventListener("click", () => {
        var text = document.querySelector(".button-expand-text span");
        var content = document.querySelector(".description.minimized");
        var icon = document.querySelector(".button-expand-text i");
        //var icon = document.querySelector(".expand-footer i");
          
        if (!content.classList.contains("expand")) {
          content.classList.add("expand");
          content.classList.remove("faded");
          content.style.maxHeight = content.scrollHeight + "px";
          icon.classList.remove("zmdi-plus");
          icon.classList.add("zmdi-minus");
          text.innerText = "Show less";
        }
        else {
          const element = document.querySelector('.title_block');

          if(document.querySelector('.product-single')) {
            var topOfElement = element.offsetTop;
          } else {
            var topOfElement = element.offsetTop;
          }
          
          window.scrollTo({ top: topOfElement, behavior: 'smooth' });
          content.classList.remove("expand");
          content.classList.add("faded");
          content.style.maxHeight = null;
          icon.classList.remove("zmdi-minus");
          icon.classList.add("zmdi-plus");
          text.innerText = "Show more";
        }
      });
    }

    $(".product-upsell").slick({
          draggable: false,
          infinite: false,
          autoplay: false,
          autoplaySpeed: 2000,
          pauseOnFocus: true,
          pauseOnHover: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: false,
          swipeToSlide: true,
          prevArrow: '<button class="slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
          nextArrow: '<button class="slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
          responsive: [
          {
              breakpoint: 992,
              settings: {
                  slidesToShow: 1,
                  draggable: true,
                  dots: true,
                  arrows: false,
              }
          }
        ]
      });

    $('.swatch :radio').change(function() {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();

        $(this)
        .closest('form')
        .find('.single-option-selector')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');
    });

    Shopify.optionsMap = {};
    Shopify.updateOptionsInSelector = function(selectorIndex) {  
        switch (selectorIndex) {
            case 0:
            var key = 'root';
            var selector = $('.single-option-selector:eq(0)');
            break;
            case 1:
            var key = $('.single-option-selector:eq(0)').val();
            var selector = $('.single-option-selector:eq(1)');
            break;
            case 2:
            var key = $('.single-option-selector:eq(0)').val();
            key += ' / ' + $('.single-option-selector:eq(1)').val();
            var selector = $('.single-option-selector:eq(2)');
        }

        var initialValue = selector.val();
        selector.empty();
        var availableOptions = Shopify.optionsMap[key];
        if (availableOptions && availableOptions.length) {
            for (var i = 0; i < availableOptions.length; i++) {
                var option = availableOptions[i];
                var newOption = $('<option></option>').val(option).html(option);
                selector.append(newOption);
            }
            $('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
                if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
                    $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
                    $(this).removeAttr('data-toggle', 'modal');
                    $(this).removeAttr('data-target', '#Form_newletter');
                    var d_qty = $('#productSelect :selected').data('qty');
                    if (d_qty < 1) {
                        $('#AddToCartText').html(''+ theme.strings.preorder +'');
                    } else {
                        $('#AddToCartText').html(''+ theme.strings.addToCart +'');
                    }
                } else {
                    $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled', 'disabled');
                    $(this).attr('data-toggle', 'modal');
                    $(this).attr('data-target', '#Form_newletter');
                    var ValueFirst = $(this).parent().find('.swatch-element:first').data('value');
                    $(this).parents('.watch_availabel').find('.variant_current').text(ValueFirst);
                }
            });
          
            if ($.inArray(initialValue, availableOptions) !== -1) {
                selector.val(initialValue);
            }
            selector.trigger('change');
        }
    };
    Shopify.linkOptionSelectors = function(product) {
        for (var i = 0; i < product.variants.length; i++) {
            var variant = product.variants[i];
            if (variant.available) {
                Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
                Shopify.optionsMap['root'].push(variant.option1);
                Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
                if (product.options.length > 1) {
                    var key = variant.option1;
                    Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                    Shopify.optionsMap[key].push(variant.option2);
                    Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
                }
                if (product.options.length === 3) {
                    var key = variant.option1 + ' / ' + variant.option2;
                    Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                    Shopify.optionsMap[key].push(variant.option3);
                    Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
                }
            }
        }
        Shopify.updateOptionsInSelector(0);
        if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
        jQuery(".single-option-selector:eq(0)").change(function() {
            Shopify.updateOptionsInSelector(1);
            if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
            return true;
        });
        jQuery(".single-option-selector:eq(1)").change(function() {
            if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
            return true;
        });
    };
  
    $(document).ready(function () {
        nuranium.init();
        nuranium.ajaxProductCountButton();

        /**********************************************
         *  SWATCH CLICK FIX – FUNÇÃO GLOBAL
         *  Funciona em coleções, sliders, quickview,
         *  tabs AJAX, infinite load e grid dinâmico.
         **********************************************/
        document.addEventListener("click", function(e) {
          const sw = e.target.closest(".swatch-element");
          if (!sw) return;

          // Impede o <a href=""> de navegar antes da troca
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();

          /* ==========================
            1. Atualiza classe .act
            ========================== */
          sw.parentElement.querySelectorAll(".swatch-element").forEach(el => {
            el.classList.remove("act");
          });
          sw.classList.add("act");

          /* ==========================
            2. Troca imagem no card
            ========================== */
          const card = sw.closest(".item-product");
          if (card && sw.dataset.imageVariant) {
            const mainImg = card.querySelector(".product__thumbnail");
            if (mainImg) {
                mainImg.setAttribute("srcset", sw.dataset.imageVariant);
                mainImg.setAttribute("src", sw.dataset.imageVariant);
            }

            const second = card.querySelector(".product__thumbnail-second");
            if (second) second.classList.add("hidden");
          }

          /* =====================================
            3. Atualiza links do produto para
                ?variant=ID da variante selecionada
            ====================================== */
          const variantId = sw.dataset.variantId;

          if (variantId) {
              card.querySelectorAll("a[href*='/products/']").forEach(a => {
                  const clean = a.href.split("?")[0];
                  a.href = clean + "?variant=" + variantId;
              });

              // O form NÃO está dentro do card — está logo após ele
              // Então procuramos no mesmo contêiner pai
              let form = card.parentElement.querySelector('form[action="/cart/add"]');

              if (form) {
                  let inputHidden = form.querySelector('input[name="id"]');
                  if (inputHidden) {
                      inputHidden.value = variantId;
                  }
              }
          }
        });
        /**********************************************
         * FIM DO BLOCO SWATCH CLICK FIX
         **********************************************/

        $('#newsletterForm').on('submit', function(e) {
            e.preventDefault();
            $('.input-group__btn').fadeOut('fast'); // Remove the submit button
            $('input[type="email"]').fadeOut('fast', function() {
              $('.success-message').fadeIn('fast'); // Show the success message after inputs are hidden
            }); // Fade out the email input field
        });

        if ($(".product-template__container").length) {
          // Se tiver marcado em algum remove
          $('.swatch.swatch_color .swatch-element').removeClass('act');
          $('.swatch.swatch_size .swatch-element').removeClass('act');
        
  
          var variantId = getParameterByName('variant');
          
          var hostname = window.location.hostname;
          var handle = $('.product-single__title').data('handle');
          
          // Construir a URL do produto
          var productUrl = "https://" + hostname + "/products/" + handle + ".json";
          
          $.ajax({
              url: productUrl,
              dataType: "json",
              success: function(data) {    
                  // Verificar se a variante existe
                  var variant = data.product.variants.find(function(v) {
                      return v.id == variantId;
                  });
          
                  if (variant) {
                      var title = variant.title;
          
                      var parts = title.split(" / ");
                      var color = parts[0];
                      var size = parts[1];
  
                      $('.swatch.swatch_color .swatch-element').each(function() {
                          if ($(this).data('value') == color) {
                            $(this).find('label').click();
                          }
                      });
          
                      $('.swatch.swatch_size .swatch-element').each(function() {
                          if ($(this).data('value') == size) {
                              $(this).addClass('act');
                          }
                      });
                  }
              },
              error: function(xhr, status, error) {
                  console.error("Erro ao carregar os dados do produto:", error);
              }
          });
        }

        $( document ).on('click', '.expand-menu-btn', function(e) {
          e.preventDefault();
          
          var text = document.querySelector(".expand-menu-btn span");
          var content = document.querySelector(".ajaxcart__inner");
          var icon = document.querySelector(".expand-menu-btn i");
            
          if (!content.classList.contains("expand")) {
            content.classList.add("expand");
            content.style.maxHeight = content.scrollHeight + "px";
            icon.classList.add("rotate");
            this.classList.add("mt-20");
            text.innerText = "Hide all products";
          }
          else {
            content.classList.remove("expand");
            content.style.maxHeight = null;
            icon.classList.remove("rotate");
            this.classList.remove("mt-20");
            text.innerText = "Show all products";
          }
      });
    });
  
    var nuranium = {
        init: function () {
          this.closeModal();
          this.novProductTabs();

          this.initNovWishListIcons();
          this.doAddOrRemoveWishlist();

          if($('body').hasClass('template-page') && $('.wishlist-page').length) {
            this.initNovWishListsPage();
          };

          this.ajaxProductAddToCart();
          this.ajaxAddToCart();
          this.ajaxChangeFromCart();
          this.initMiniCart();
          this.ajaxProductCountButton();
          this.ajaxRemoveFromCart();
          this.initQuickView();
          this.initQuickVariants();
          this.changeQuantityPageCart();
          this.initCollapseSidebarBlock();
        },

        initCollapseSidebarBlock: function() {
            $(document).on("click", ".facets__label", t => {
                var a = $(t.currentTarget),
                    o = a.parent().find(".facets__content");
                a.hasClass("act") ? (a.removeClass("act"), o.slideUp()) : (a.addClass("act"), o.slideDown())
            })
        },
        initSwatchColor: function() {
          $(".section-collection-tabs .product-swatch-color").each(function() {
              var n = $(this).children('.swatch-element').length - 3;
              if ($(this).children('.swatch-element').length > 3) {
                  $(this).find('.number').text(n);
                  $(this).find('.show_more').show();
              }
              $(this).find('.swatch-element:gt(2)').addClass('hide');
              $(this).children('.show_more').click(function () {
                  if ($(this).hasClass('active')) {
                      $(this).parent('.swatch-element').removeClass('act');
                      $(this).parent().find('.hide').hide();
                      $(this).removeClass('active');
                      $(this).parent().find('.number').show();
                  } else {
                      $(this).parent('.swatch-element').addClass('act');
                      $(this).parent().find('.hide').show();
                      $(this).addClass('active');
                      $(this).parent().find('.number').hide();
                  }
              })
          })
        },

        closeModal: function() {
            $('.close-modal, .overlay').click(function() {
                $('.loading-modal').css({"opacity": "0", "visibility": "hidden", "transform": "translateX(410px)", "transition": "all 0.3s"});;
            });
        },

        novProductTabs: function () {
            var productTabs = $('[data-product-tabs]');

            productTabs.each(function () {
                var self = $(this),
                    listTabs = self.find('.list-product-tabs'),
                    tabLink = listTabs.find('[data-product-tabTop]'),
                    tabContent = self.find('[data-product-TabContent]'),
                    linkActive = self.find('.list-product-tabs .tab-links.active'),
                    activeTab = self.find('.product-tabs-content .tab-content.active');

                nuranium.doAjaxNovProductTabs(linkActive.data('href'), activeTab.find('.loading'), activeTab.find('.products-grid'));

                tabLink.off('click').on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    if ($(this).hasClass('active')) {
                        return;
                    }

                    if (!$(this).hasClass('active')) {
                        var curTab = $(this),
                            curTabContent = $(curTab.data('target'));

                        tabLink.removeClass('active');
                        tabContent.removeClass('active');    

                        if (!curTabContent.find('.products-grid').hasClass('slick-initialized')) {
                            nuranium.doAjaxNovProductTabs(curTab.data('href'), curTabContent.find('.loading'), curTabContent.find('.products-grid'));
                        }            

                        curTab.addClass('active');
                        curTabContent.addClass('active');
                    }
                });
            });
        },

        doAjaxNovProductTabs: function(handle, loadingElement, curTabContent) {
            $.ajax({
                type: "GET",
                url: window.router + handle,
                success: function (data) {
                    loadingElement.hide();

                    if (handle == '/collections/?view=json' || handle == '/collections/?view=new-json') {
                        
                    } else {
                        curTabContent.html($(data).find('.grid-item').html());
                        if (curTabContent.hasClass('collection-carousel')) {
                            if (!curTabContent.hasClass('slick-initialized')) {
                                nuranium.initNovProductTabsSlider(curTabContent.parent());
                            };
                        } else {
                            var row = curTabContent.data('items');
                            switch (row) {
                                case 1:
                                    var _class = 'col-lg-12';
                                    break;
                                case 2:
                                    var _class = 'col-lg-6';
                                    break;
                                case 3:
                                    var _class = 'col-lg-4';
                                    break;
                                case 4:
                                    var _class = 'col-lg-3';
                                    break;
                                case 5:
                                    var _class = 'col-lg-5';
                                    break;
                                case 6:
                                    var _class = 'col-lg-2';
                                    break;
                            }
                        };
                        
                        curTabContent.find('.grid-item').addClass(_class);
                
                        Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));

                        nuranium.initNovWishListIcons();
                        nuranium.initSwatchColor();
                      
                        /*setTimeout(function () {
                            if ($('.shopify-product-reviews-badge').length && $('.spr-badge').length) {
                                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                            };
                        }, 1000);*/
                    };
                }
            });
        },
        
        initNovProductTabsSlider: function (tabslider) {
            tabslider.each(function () {
                var self = $(this),
                    productGrid = self.find('.products-grid'),
                    t = !!$("html").hasClass("lang-rtl");

                if (productGrid.not('.slick-initialized')) {
                    productGrid.slick({
                        nextArrow: '<div class="arrow-next"><i class="zmdi zmdi-chevron-right" aria-hidden="true"></i></div>',
                        prevArrow: '<div class="arrow-prev"><i class="zmdi zmdi-chevron-left" aria-hidden="true"></i></i></div>',
                        rtl: t,
                        slidesToShow: (productGrid.data("loop"), productGrid.data("items")),
                        slidesToScroll: (productGrid.data("loop"), productGrid.data("1")),
                        rows: productGrid.data("row"),
                        arrows: productGrid.data("nav"),
                        dots: productGrid.data("dots"),
                        infinite: productGrid.data("loop"),
                        adaptiveHeight: !0,
                        responsive: [
                            { 
                                breakpoint: 1920, 
                                settings: { 
                                    slidesToShow: (
                                        productGrid.data("loop"), 
                                        productGrid.data("items")
                                        ), 
                                    slidesToScroll: (productGrid.data("loop"), 
                                        productGrid.data("1")) 
                                } 
                            },
                            { 
                                breakpoint: 1439, 
                                settings: { 
                                    slidesToShow: productGrid.data("items_lg_desktop"), 
                                    slidesToScroll: productGrid.data("1") 
                                } 
                            },
                            { 
                                breakpoint: 1200, 
                                settings: { 
                                    slidesToShow: productGrid.data("items_lg_tablet"), 
                                    slidesToScroll: productGrid.data("1") 
                                } 
                            },
                            { 
                                breakpoint: 992, 
                                settings: { 
                                    slidesToShow: productGrid.data("items_tablet"), 
                                    slidesToScroll: productGrid.data("1") 
                                } 
                            },
                            { 
                                breakpoint: 768, 
                                settings: { 
                                    slidesToShow: productGrid.data("items_mobile"), 
                                    slidesToScroll: productGrid.data("1") 
                                } 
                            },
                            { 
                                breakpoint: 480, 
                                settings: { 
                                    slidesToShow: productGrid.data("items_mobiles"), 
                                    slidesToScroll: productGrid.data("1"), arrows: !1 
                                } 
                            },
                        ]
                    });
                }
            });
        },
                  
        initNovWishListsPage: function() {
            if (typeof(Storage) !== 'undefined') {               
                if (wishListsArr.length <= 0) {
                   return;
                }

                wishListsArr.forEach(function(item) {
                   nuranium.createNovWishListTplItem(item);             
                });
            } else {
                alert('Storage no support!');
            }
        },
        
        initNovWishListIcons: function() {
            if (!wishListsArr.length) {
                return;
            }

            for (var i = 0; i < wishListsArr.length; i++) {
                var icon = $('[data-product-handle="'+ wishListsArr[i] +'"]');
                icon.addClass('whislist-added');
                icon.find('.wishlist-text').text('Remove WishList');
            };

            if (typeof(Storage) !== 'undefined') {
                if (wishListsArr.length <= 0) {
                    return;
                }

                setTimeout(function() {
                    wishListsArr.forEach(function(item) {
                        nuranium.setNovAddedForWishlistIcon(item);     
                    });
                }, 1000);
            } else {
                alert('Storage no support!');
            }
        },
        
        setNovAddedForWishlistIcon: function(ProductHandle) {
            var wishlistElm = $('[data-product-handle="'+ ProductHandle +'"]'),
                idxArr = wishListsArr.indexOf(ProductHandle);

            if (idxArr >= 0) {
                wishlistElm.addClass('whislist-added');
                wishlistElm.find('.wishlist-text').text('Remove WishList');
            }
            else {
                wishlistElm.removeClass('whislist-added');
                wishlistElm.find('.wishlist-text').text('Add to WishList');
            };
        },
          
        doAddOrRemoveWishlist: function() {   
            var iconWishLists = '.item-product [data-icon-wishlist]';

            $(document).off('click.addOrRemoveWishlist', iconWishLists).on('click.addOrRemoveWishlist', iconWishLists, function(e) {
                e.preventDefault();

                var self = $(this),
                    productId = self.data('id'),
                    ProductHandle = self.data('product-handle'),
                    idxArr = wishListsArr.indexOf(ProductHandle);

                if (!self.hasClass('whislist-added')) {
                    self.addClass('whislist-added');
                    self.find('.wishlist-text').text('Remove WishList');
                    
                    var title = self.parents('.item-product').find('.product__title').html();
                    var image = self.parents('.item-product').find('.product__thumbnail').attr('srcset');
                    
                    $('.loading-modal').find('.product-title').html(title);
                    $('.loading-modal').find('.product-image').attr('srcset', image);
                    $('.loading-modal').find('.btn-wishlist').show();
                    $('.loading-modal').css({"display": "block","opacity": "1", "visibility": "initial", "transform": "translateX(0)", "transition": "all 0.3s"});
                    setTimeout(function() {
                        $('.loading-modal').css({"opacity": "0", "visibility": "hidden", "transform": "translateX(410px)", "transition": "all 0.3s"});
                    }, 5000);

                    if ($('[data-wishlist-container]').length) {
                        nuranium.createNovWishListTplItem(ProductHandle);
                    };

                    wishListsArr.push(ProductHandle);
                    localStorage.setItem('wishListsArr', JSON.stringify(wishListsArr));

                } else {
                    self.removeClass('whislist-added');
                    self.find('.wishlist-text').text('Add to WishList');
              
              
                    if ($('[data-wishlist-added="wishlist-'+productId+'"]').length) {
                        $('[data-wishlist-added="wishlist-'+productId+'"]').remove();
                    }

                    wishListsArr.splice(idxArr, 1);
                    localStorage.setItem('wishListsArr', JSON.stringify(wishListsArr));
                };

                nuranium.setNovAddedForWishlistIcon(ProductHandle);
            });
        },
        
        createNovWishListTplItem: function(ProductHandle) {
            var wishListCotainer = $('[data-wishlist-container]');

            jQuery.getJSON(window.router + '/products/'+ProductHandle+'.js', function(product) {
                var productHTML = '',
                    price_min = Shopify.formatMoney(product.price_min, "£ {{amount_with_comma_separator}}");

                productHTML += '<div class="grid-item" data-wishlist-added="wishlist-'+product.id+'">';
                productHTML += '<div class="inner item-product row align-items-center" data-product-id="product-'+product.handle+'">';
                productHTML += '<div class="column_content col-xl-5 col-lg-5 col-md-4 col-sm-12 col-xs-12"><div class="product-image">';
                productHTML +='<a href="'+product.url+'" class="product-grid-image" data-collections-related="/collections/all?view=related">';
                productHTML += '<img src="'+product.featured_image+'" alt="'+product.featured_image.alt+'">';
                productHTML += '</a></div>';
                productHTML += '<div class="product-info">';
                productHTML += '<div class="product-title">';
                productHTML += '<a href="'+product.url+'" title="'+product.title+'">'+product.title+'</a></div></div></div>';
                productHTML += '<div class="column_content col-xl-3 col-lg-3 col-md-2 col-sm-12 col-xs-12 text-center"><div class="price-box">'+ price_min +'</div></div>';
                productHTML += '<div class="column_content col-xl-2 col-lg-2 col-md-3 col-sm-12 col-xs-12 text-center"><a class="btn whislist-added" href="#" data-product-handle="'+ product.handle +'" data-icon-wishlist data-id="'+ product.id +'"><i class="fa fa-trash-o" aria-hidden="true"></i>'+ theme.strings.remove +'</a></div>';
                productHTML += '<div class="column_content col-xl-2 col-lg-2 col-md-3 col-sm-12 col-xs-12 text-center">';
                productHTML += '<form action="/cart/add" method="post" class="variants formAddToCart" id="-'+product.id+'" data-id="product-actions-'+product.id+'" enctype="multipart/form-data">';

                if (product.available) {
                    if (product.variants.length == 1) {
                        productHTML += '<a href="'+product.url +'" class="btn btnAddToCart" title="'+product.title+'" href="javascript:void(0);" data-url="'+product.url +'?view=json"><i class="zmdi zmdi-check"></i><span>'+ theme.strings.select_options +'</span></a>';
                    } 
                    if (product.variants.length > 1){
                        productHTML += '<a href="'+product.url +'" class="btn btnAddToCart" title="'+product.title+'" href="javascript:void(0);" data-url="'+product.url +'?view=json"><i class="zmdi zmdi-check"></i><span>'+ theme.strings.select_options +'</span></a>';
                    }
                } else {
                    productHTML += '<button class="btn btnAddToCart" type="button" disabled="disabled">'+ theme.strings.soldOut +'</button>';
                }

                productHTML += '</form></div>';

                productHTML += '</div></div>';

                wishListCotainer.append(productHTML);
            });
        },
          
        ajaxAddToCart: function() {
          $( document ).on('click', 'button.btnAddToCart', function(e) {
            e.preventDefault();
            var $this = $(this),
                variant_id = $this.data('pid');
            $this.addClass('btn-loading');
            $this.parent().addClass('fix_nt_tt');
            //$( 'body' ).addClass('loading');
            
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {quantity: 1, id:variant_id},
              dataType: 'json',
              success:function( cart ) {
                $.get('/cart?view=json', function(data) {
                  $('#cart-info').html(data);
                }).always(function() {
                  Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
                  
                  nuranium.initAddToCart(cart.image, cart.title);
                  
                  nuranium.updateMiniCart();
                  
                  nuranium.PopupAddToCart();
                  
                  nuranium.initQuickVariants();
                  
                  $this.removeAttr("disabled").css('pointer-events', 'auto').removeClass("btn-loading");
                  $( 'body' ).removeClass('loading');
                  
                  $(document).find('.quickviewClose').trigger('click');
                });
              },
              error: function(XMLHttpRequest, textStatus) {
                $this.removeClass("btn-loading");
                
              }
            }).done(function() {
                $( 'body' ).removeClass('loading');
            });
          })
        },
        
        initAddToCart : function(image, title) {
            $.ajax({
                url: '/cart/?view=upsell',
                dataType: 'html',
                type: 'GET',
                beforeSend : function (){
                    $( 'body' ).addClass('cart_popup_opened');
                    $('body').addClass('loading');
                    $( '#jas-wrapper' ).after( '<div class="loader"><div class="loader-inner"></div></div>' );
                },
                success: function(data) {
                    $.magnificPopup.open({
                        items: {
                            src: '<div class="nov-with-anim product-quickview popup-quick-view cart__popup cart__popup_upsell"><div id="content_cart__popup_nt">' + data + '</div></div>',
                            type: 'inline'
                        },
                        removalDelay: 1000,
                        closeMarkup: '<i class="zmdi zmdi-hc-fw zmdi-close"></i>',
                        callbacks: {
                            beforeOpen: function() {
                                this.st.mainClass = 'nov-move-horizontal';
                            },
                            open: function() {
                                nuranium.PopupAddToCart();
                                nuranium.initQuickVariants();
                                Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
                            },
                            change: function() { },
                            close: function() {
                                if($('body').hasClass('template-cart')) {
                                    window.location.reload();
                                }
                                else {
                                    $('body').removeClass('cart_popup_opened');
                                    $('body').removeClass('open_quick_variants');
                                    $('body').removeClass('loading');
                                    $('#content_cart__popup_nt').empty();
                                }
                            }
                        },
                    });
                },
                complete: function() {
                    nuranium.PopupAddToCart();
                    Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
                    $('.loader').remove();
                },
                error: function() {
                    $('.loader').remove();
                }
            }).done(function() {
                $( 'body' ).removeClass('loading');
            });
        },
        
        ajaxProductCountButton: function() {
          if($(document).width() < 767 ) {
            jQuery.getJSON("/cart.js", function (cart) {
              if (cart.items.length > 2) {
                $('.expand-menu-btn').removeClass("hide");
              } else {
                $('.expand-menu-btn').addClass("hide");
              }
            });
          } else {
            $('.expand-menu-btn').addClass("hide");            
          }
        },
      
        updateMiniCart: function() {
          Shopify.getCart(function(cart) {
            nuranium.doUpdateMiniCart(cart);
          });
        },

        doUpdateMiniCart: function(cart, product_id) {
          $('.ajax-cart-count').text(cart.item_count);
          $('#CartCount').text(cart.item_count);
          
          if (cart.item_count > 0) {
            nuranium.ajaxProductCountButton();
            
            if (product_id) {
              $.each(cart.items, function(index, obj){
                  if(obj.id === product_id){
                      position = index;
                      return false;
                  }
              });
  
              $('.product-cart-price .product-price .money.final_price[data-id='+product_id+']').text(Shopify.formatMoney(cart.items[position].final_line_price, theme.moneyFormat));
            }
  
            $('.cart-products-count').text(cart.items.length);
            $('.ajaxcart__footer .subtotal .money, .ajaxcart__footer .total .money').text(Shopify.formatMoney(cart.total_price, theme.moneyFormat));
            
            $(".ajax-cart-count").text(cart.item_count)
  
            if (cart.item_count > 1 || cart.item_count == 0) {
              $(".cart-item-qty-text").text("items");
            } else {
              $(".cart-item-qty-text").text("item");                  
            }
  
            if (cart.item_count <= 0) {
              $('.cart-popup-heading span').html('Sua sacola está vazia :(');            
            } else if (cart.item_count == 1) {
              $('.cart-popup-heading span').html('Há ' + cart.item_count + ' produto na sua sacola');            
            } else {
              $('.cart-popup-heading span').html('Há ' + cart.item_count + ' produtos na sua sacola');            
            }
          } else {
                if (cart.item_count > 1 || cart.item_count == 0) {
                  $(".cart-item-qty-text").text("items");
                } else {
                  $(".cart-item-qty-text").text("item");                  
                }
            	
                $('.ajaxcart__footer').addClass('hide');
          }
        },

        ajaxChangeFromCart: function() {
          $( document ).on( 'change','.cart__popup-qty--input', function( e ) {
            e.preventDefault();
          })
        },
              
        PopupAddToCart: function() {
          function PopupUpdateCart(_id, new_qty) {
            $('.cart__popup').addClass('loading');
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: 'quantity=' + new_qty + '&id=' + _id,
              dataType: 'json',
              success: function (cart) {
                jQuery.get('/cart?view=up_ajax', function (data) {
                  data = jQuery(data);
                  var sdata = jQuery(data);
                  var t_html = jQuery(sdata.get(0)).html(),
                      t_threshold = jQuery(sdata.get(2)).html(),
                      t_total = $('.cart__popup #' + _id).find('.cart__popup-total .amount');
                  
                  $('.cart__popup #' + _id).find('.cart__popup-qty--input').val(new_qty);
                  
                  var price = parseFloat(t_total.data('price')) * new_qty;
                  t_total.html(Shopify.formatMoney(price, theme.moneyFormat));
                  $('#cart__popup_total').html(t_html);
                  $('#threshold_bar_popup').html(t_threshold);
                }).always(function () {
                  Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
                  $('.cart__popup').removeClass('loading');
                });
                
                $.get('/cart?view=json', function (data) {
                  $('#cart-info').html(data);
                }).always(function () {
                  Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
                  nuranium.updateMiniCart();
                });
              },
              error: function (XMLHttpRequest, textStatus) {
                $('.cart__popup').removeClass('loading');
              }
            });
          }
          
          $(document).on('click', '.cart__popup-qty', function (e) {
            e.preventDefault();
            
            var $this = $(this),
                $qty = $this.siblings('.cart__popup-qty--input'),
                $id = $qty.attr('data-id'),
                $qtyinput = parseFloat($qty.val()),
                $step = parseFloat($qty.attr('step')),
                $min = parseFloat($qty.attr('min')),
                $max = parseFloat($qty.attr('max'));
            
            if ($this.hasClass('cart__popup-qty--plus')) {
              var $newqty = $qtyinput + $step;
              if ($newqty > $max && $max > 0) {
                $qty.val($max);
                // alert('Maximum Quantity: ' + $max);
                return;
              }
            }
            else if ($this.hasClass('cart__popup-qty--minus')) {
              var $newqty = $qtyinput - $step;
              if ($newqty === 0) {
                var last_qty = parseInt($qty.attr('value'));
                $qty.val(last_qty);
                $this.parents('.cart__popup-item').find('.cart__popup-remove').trigger('click');
                return;
              } else if ($newqty < $min) {
                return;
              } else if ($qtyinput < 0) {
                alert('Invalid');
                return;
              }
            }
            
            PopupUpdateCart($id, $newqty);
          });
          
          $(document).on('click', '.cart__popup-remove', function (e) {
            e.preventDefault();
            
            $('.cart__popup').addClass('loading');
            
            var $this = $(this),
                $qty = $this.siblings('.cart__popup-quantity').find('.cart__popup-qty--input'),
                $id = $this.find('a').attr('data-product-id'),
                $qtyinput = parseInt($qty.val());
                $ptitle = $this.parent('.cart__popup-item').find('.cart__popup-title a').text();
            
            $('.cart__popup').addClass('loading');
            
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: 'quantity=0&id=' + $id,
              dataType: 'json',
              success: function (cart) {
                jQuery.get('/cart?view=up_ajax', function (data) {}).always(function (data) {
                  data = jQuery(data);
                  var sdata = jQuery(data);
                  var t_html = jQuery(sdata.get(0)).html(),
                      t_threshold = jQuery(sdata.get(2)).html();;
                  $('#cart__popup_total').html(t_html);
                  $('#threshold_bar_popup').html(t_threshold);
                  $('.cart__popup #' + $id).addClass('hide');
                  if ($qtyinput > 0) {
                    $('#' + $id + ' input').val($qtyinput)
                  } else {
                    $('.cart__popup #' + $id + ' input').val(1)
                  }
                  
                  Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
                  
                  $('.cart__popup .cart-message').html('<i class="fa fa-trash-o"></i> <strong>'+ $ptitle +'</strong>  foi removido da sua sacola.');
                  
                  $('.cart__popup .cart-message').removeClass('removed').addClass('removed');
                  
                  $('.cart__popup').removeClass('loading');
                  
                  $this.parents('.cart__popup-item').remove();
                });
                
                $.get('/cart?view=json', function (data) {
                  $('#cart-info').html(data);
                }).always(function () {
                  Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
                  
                  nuranium.updateMiniCart();
                });
              }
            })
          });
        },
          
        initMiniCart: function() {
          jQuery.getJSON("/cart.js", function (cart) {
            $('#CartCount').text(cart.item_count);
            $('.ajaxcart__inner').html('');
            if (cart.item_count > 0) {
              var html = '';
              
              for (var i = 0; i < cart.items.length; i++) {
                var image = Shopify.resizeImage(cart.items[i].image, 'medium');
                var price = Shopify.formatMoney(cart.items[i].final_line_price, theme.moneyFormat);
                var compareAtPrice = Shopify.formatMoney(cart.items[i].compare_at_price, theme.moneyFormat);
                
                html += '<div class="ajaxcart__product" data-line="'+i+'">';
                html += '<div class="media">';
                html += '<a href="'+cart.items[i].url+'"><img class="d-flex product-image" src="'+image+'" alt="'+cart.items[i].title+'" title="'+cart.items[i].title+'"></a>';
                html += '<div class="media-body">';
                html += '<div class="d-flex justify-content-between">';
                html += '<a class="product-name" href="'+cart.items[i].url+'">';
                html += '<span class="title">'+cart.items[i].product_title+'</span>';
                if (cart.items[i].variant_title)
                    html += '<span class="bt_s">'+cart.items[i].variant_title+'</span>';
                html += '</a>';
                html += '<div class="product-cart-price">';
                html += '<span class="product-price"><span class="money final_price" data-id="'+cart.items[i].id+'">'+price+'</span></span>';
                html += '</div>';
                html += '</div>';
                
                html += '<div class="d-flex">';
                html += '<div class="cart__qty d-flex">';
                html += '<a class="btn-qty minus" href="javascript:void(0);"><i class="zmdi zmdi-minus"></i></a>';
                html += '<input class="cart__qty-input" type="number" name="updates[]" id="updates_'+cart.items[i].key+'" data-price="'+cart.items[i].price+'" data-id="'+cart.items[i].id+'" data-line="'+i+'" step="1" value="'+cart.items[i].quantity+'" min="1" max="10" pattern="[0-9]*" readonly="readonly" />';
                html += '<a class="btn-qty plus" href="javascript:void(0);"><i class="zmdi zmdi-plus"></i></a>';
                html += '</div>';

                html += '<a class="remove-from-cart" rel="nofollow" href="javascript:void(0);" title="Remove item" data-line="'+i+'" data-product-id="'+cart.items[i].id+'">Remove</a>';
                
                html += '</div>';
                
                html += '</div>';
                html += '</div>';
                html += '</div>';
              }
              
              $('.ajaxcart__inner').append(html);

              // Update cart
              $('.cart-products-count').text(cart.items.length);
              $('.ajaxcart__footer .subtotal .money, .ajaxcart__footer .total .money').text(Shopify.formatMoney(cart.total_price, theme.moneyFormat));
              
              Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
            } else {
            	var link_collection = $('.link_to_collection_cart_empty').html();
            	var html = '';
            	html += '<div class="cart_empty">';
            	html += '<h4 class="text-center mt-60 mb-20">Your bag is currently empty</h4>';
            	html += '<div class="empty_title text-center mt-10">Before proceeding to checkout you must add some products to your bag.</div>';
            	html += '<div class="text-center mt-40 block_link_cart">';
            	html += ''+ link_collection +'';
            	html += '</div>';
            	html += '</div>';

                if (cart.item_count > 1 || cart.item_count == 0) {
                  $(".cart-item-qty-text").text("items");
                } else {
                  $(".cart-item-qty-text").text("item");                  
                }
            	
                $('.ajaxcart__inner').addClass('empty').append(html);
                $('.ajaxcart__footer').addClass('hide');
            }
          })
        },
        
        ajaxProductAddToCart: function() {
          $(document).on('click', '.product-form__cart-submit', function (e) {
            e.preventDefault();

            const $btn = $(this);
            const $form = $btn.closest('form');

            /* prevent double submit */
            if ($btn.hasClass('cart-adding')) return;

            $btn
              .attr('disabled', true)
              .css('pointer-events', 'none')
              .addClass('cart-adding');

            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: $form.serialize(),
              dataType: 'json'
            })
            .done(function () {

              /* fetch updated cart */
              fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {

                  /* update mini cart DOM */
                  if (typeof updateDOM === 'function') {
                    updateDOM(cart);
                  }

                  /* open mini cart */
                  $('body').addClass('minicart-right');
                  $('.mini-cart').addClass('active');
                  $('.canvas-overlay').addClass('active');
                });
            })
            .always(function () {

              /* reset button */
              $btn
                .removeAttr('disabled')
                .css('pointer-events', 'auto')
                .removeClass('cart-adding');

              /* close quickview if exists */
              $('.quickviewClose').trigger('click');
            });
          });
        },
        
        initQuickView: function() {
            $(document).on('click', '.btnProductQuickview', function(e) {
                e.preventDefault();

                var $this = $(this);

                $.ajax({
                    beforeSend : function (){
                        $this.addClass('btn-loading');
                        $('body').addClass('open_gl_quick_view');
                        $('body').addClass('loading');
                    },
                    url: $this.attr('data-url'),
                    success: function(data) {
                        $.magnificPopup.open({
                            items: {
                                src: '<div class="nov-with-anim popup-quick-view" id="content_quickview">' + data + '</div>',
                                type: 'inline'
                            },
                            removalDelay: 1000,
                            closeMarkup: '<i class="zmdi zmdi-hc-fw zmdi-close"></i>',
                            callbacks: {
                                beforeOpen: function() {
                                    this.st.mainClass = 'nov-move-horizontal';
                                },
                                open: function() {
                                    if ($('html').hasClass('lang-rtl'))
                                        rtl = true;
                                    else
                                        rtl = false;
                                    var autoplay = $("#productThumbs .owl-carousel").data('autoplay');
                                    var autoplayTimeout = $("#productThumbs .owl-carousel").data('autoplayTimeout');
                                    var items = $("#productThumbs .owl-carousel").data('items');
                                    var margin = $("#productThumbs .owl-carousel").data('margin');
                                    var nav = $("#productThumbs .owl-carousel").data('nav');
                                    var dots = $("#productThumbs .owl-carousel").data('dots');
                                    var loop = $("#productThumbs .owl-carousel").data('loop');
                                    var items_tablet = $("#productThumbs .owl-carousel").data('items_tablet') ? $("#productThumbs .owl-carousel").data('items_tablet') : 3;
                                    var items_mobile = $("#productThumbs .owl-carousel").data('items_mobile') ? $("#productThumbs .owl-carousel").data('items_mobile') : 1;
                                    var center = $("#productThumbs .owl-carousel").data('center') ? $("#productThumbs .owl-carousel").data('center') : false;
                                    var start = $("#productThumbs .owl-carousel").data('start') ? $("#productThumbs .owl-carousel").data('start') : 0;
                                    $("#productThumbs .owl-carousel").owlCarousel({
                                        navText: ['<i class="fa fa-long-arrow-left"></i>', '<i class="fa fa-long-arrow-right"></i>'],
                                        lazyLoad: true,
                                        lazyContent: true,
                                        loop: loop,
                                        autoplay: autoplay,
                                        autoplayTimeout: autoplayTimeout,
                                        items: items,
                                        margin: margin,
                                        rtl: rtl,
                                        dots: dots,
                                        nav: nav,
                                        responsive: {
                                            0: {
                                                items: items_mobile,
                                                center: center,
                                                margin: 10
                                            },
                                            768: {
                                                items: items_tablet,
                                                margin: 10
                                            },
                                            992: {
                                                items: items,
                                                margin: margin
                                            },
                                            1200: {
                                                items: items,
                                                startPosition: start,
                                                margin: margin
                                            },
                                        }
                                    });
                                    Shopify.PaymentButton.init();

                                    Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));

                                    setTimeout(function () {
                                        if ($('.shopify-product-reviews-badge').length && $('.spr-badge').length) {
                                            return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                                        };
                                    }, 1000);

                                    jQuery(function() {
                                        jQuery('.swatch :radio').change(function() {
                                            var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
                                            var optionValue = jQuery(this).val();
                                            var sku = jQuery(this).data('sku');
                                            jQuery(this)
                                            .closest('form')
                                            .find('.single-option-selector')
                                            .eq(optionIndex)
                                            .val(optionValue)
                                            .trigger('change');

                                            $(this).parents('.watch_availabel').find('span.variant_current').text(optionValue);
                                            $('#content_quickview .variant-sku').text(sku);
                                        });
                                    });
                                    $('.swatch-element[data-toggle="modal"]').click(function () {
                                        $('.nov-bg').css('opacity', '0');
                                        $('#content_quickview').css('opacity', '0');
                                    })
                                    $('#Form_newletter').on('hidden.bs.modal', function () {
                                        $('.nov-bg').css('opacity', '0.8');
                                        $('#content_quickview').css('opacity', '1');
                                    })
                                },
                                close: function() {
                                    $( '#content_quickview' ).empty();
                                    $('body').removeClass('open_gl_quick_view');
                                    $('body').removeClass('cart_popup_opened');
                                    $('body').removeClass('open_quick_variants');
                                    $('body').removeClass('loading');
                                }
                            },
                        });
                    },
                    complete: function() {
                        Shopify.PaymentButton.init();
                    }
                }).done(function() {
                    $this.removeClass('btn-loading');
                    $('body').removeClass('loading');
                })
            })
        },
          
        initQuickVariants: function() {
            $(document).on('click', '.btnChooseVariant', function(e) {
                e.preventDefault();

                var $this = $(this);

                $.ajax({
                    beforeSend : function (){
                        $this.addClass('btn-loading');
                        $('body').addClass('open_quick_variants');
                        $('body').addClass('loading');

                    },
                    url: $this.attr('data-url'),
                    success: function(data) {
                        $.magnificPopup.open({
                            items: {
                                src: '<div class="nov-with-anim popup-quick-view" id="content_variants">' + data + '</div>',
                                type: 'inline'
                            },
                            removalDelay: 1000,
                            closeMarkup: '<i class="zmdi zmdi-hc-fw zmdi-close"></i>',
                            callbacks: {
                                beforeOpen: function() {
                                    this.st.mainClass = 'nov-move-horizontal';
                                },
                                open: function() {
                                    Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));

                                    jQuery(function() {
                                        jQuery('.swatch :radio').change(function() {
                                            var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
                                            var optionValue = jQuery(this).val();
                                            jQuery(this)
                                            .closest('form')
                                            .find('.single-option-selector')
                                            .eq(optionIndex)
                                            .val(optionValue)
                                            .trigger('change');

                                            $(this).parents('.watch_availabel').find('span.variant_current').text(optionValue);
                                        });
                                    });
                                    $('.swatch-element[data-toggle="modal"]').click(function () {
                                        $('.nov-bg').css('opacity', '0');
                                        $('#content_variants').css('opacity', '0');
                                    })
                                    $('#Form_newletter').on('hidden.bs.modal', function () {
                                        $('.nov-bg').css('opacity', '0.8');
                                        $('#content_variants').css('opacity', '1');
                                    })

                                    nuranium.PopupAddToCart();
                                },
                                close: function() {
                                    if($('body').hasClass('template-cart')) {
                                        window.location.reload();
                                    }
                                    else {
                                        $( '#content_variants' ).empty();
                                        $('body').removeClass('open_quick_variants');
                                        $('body').removeClass('cart_popup_opened');
                                        $( 'body' ).removeClass('loading');
                                    }
                                }
                            },
                        });
                    },
                    complete: function() {
                        Shopify.PaymentButton.init();

                        jQuery(function() {
                            jQuery('.swatch :radio').change(function() {
                                var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
                                var optionValue = jQuery(this).val();
                                jQuery(this)
                                .closest('form')
                                .find('.single-option-selector')
                                .eq(optionIndex)
                                .val(optionValue)
                                .trigger('change');

                                $(this).parents('.watch_availabel').find('span.variant_current').text(optionValue);
                            });
                        });
                    }
                }).done(function() {
                    $this.removeClass('btn-loading');
                    $('body').removeClass('loading');
                })
            })
        },
          
        ajaxRemoveFromCart: function() {
          $('#cart-info').on('click', '.remove-from-cart', function(e) {
            e.preventDefault();

            $(e.target).closest(".ajaxcart__product").addClass("loading").append('<span class="spinner"><svg viewBox="0 0 100 100"><circle cx="50" cy="50" r="20"></circle></svg></span>');
            
            var $this = $(this),
                $id = $this.attr('data-product-id');

            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: 'quantity=0&id=' + $id,
              dataType: 'json',
              success: function (cart) {
                nuranium.ajaxProductCountButton();
                nuranium.updateMiniCart();
                nuranium.updateMiniCartContent();
                
                if(cart.item_count == 0) {
                  $('.ajaxcart__footer').addClass('hide');
                }                
                
                if ($('body').hasClass('template-cart')) {
                  window.location.reload();
                }
                else {
                  nuranium.initMiniCart();
                }
                
              }
            })
            
          });
        },
        
        updateMiniCartContent: function(product_added) {
          var content = $('.ajaxcart__inner');

          // if(product_added && $(document).width() < 767) {
          //   jQuery.getJSON("/cart.js", function (cart) {
          //     if (cart.items.length > 1) {
          //       var lastPosition = cart.items.length - 1; // OK
  
          //       var newItemSize = $(`.ajaxcart__product[data-line="${lastPosition}"]`).height();
          //       var newHeight = content.height() + newItemSize;
              
          //       console.log(newItemSize+" | "+ newItemSize)
          //       content.css('max-height', newHeight + "px");
          //     }
          //   });
          // }
          
          if (content.hasClass("expand")) {
            var itemSize = $('.ajaxcart__product').height();
            var newHeight = content.height() - itemSize;
            
            content.css('max-height', newHeight + "px");
          } else {
            nuranium.initMiniCart();
          }         
       },
          
        changeQuantityPageCart: function() {
          function ShopifyCartChange(variant_id, quantity, callback) {
            var params = {
              type: 'POST',
              url: '/cart/change.js',
              data:  'quantity='+quantity+'&line='+variant_id,
              dataType: 'json',
              success: function(cart) {
                if ((typeof callback) === 'function') {
                  callback(cart);
                }
              },
              error: function(XMLHttpRequest, textStatus) {
                
              }
            };
            jQuery.ajax(params);
          }
          
          $( document ).on( 'change keyup', '.cart__qty-input, .cart__popup-qty--input', function(e) {
            var $this = $(this);
            var line = $this.data('line'),
                val = parseInt($this.val()),
                price = $this.data('price'),
                max = $this.attr('max');
            if(isNaN(val)) return 0;
            
            max = isNaN(parseInt(max)) ? 9999: parseInt(max);
            if(val > max )
            {
              $this.attr('value', max).val(max);
            }
            val = (val > max) ? max : val;
            
            if(val <= 0 ){
              $this.closest('tr').remove();
            }
            
            //Update cart
            // ShopifyCartChange(line, val, function(res) {
            //   $('.cart__subtotal').html(Shopify.formatMoney(res.total_price, theme.moneyFormat));

            //   $('.cart-products-count').text(res.items.length);
            //   $('.ajaxcart__footer .subtotal .money, .ajaxcart__footer .total .money').text(Shopify.formatMoney(res.total_price, theme.moneyFormat));
              
            //   $this.parents('.cart_item').find('.product-subtotal').html(Shopify.formatMoney(price * val, theme.moneyFormat));
              
            //   $('#CartCount').html(res.item_count);

            //   if (res.item_count <= 0) {
            //     $('.cart__heading span').html('Sua sacola está vazia :(');
            //   } else {
            //     $('.cart__heading span').html('Há '+res.item_count+' produtos na sua sacola');                
            //   }
              
            //   Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
              
            //   jQuery.get('/cart?view=ship', function(data) {
            //     $('#threshold_bar_popup').html(data);
            //     setTimeout(function() {
            //       Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
            //     }, 200);   
            //   });
              
            //   jQuery.getJSON("/cart.js", function (cart) {
            //     console.log(cart)
            //   }).always(function () {
            //     Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
            //     nuranium.updateMiniCart();
            //   });
            // });
            
          });
          
          $( document ).on( 'click', '.plus, .minus', function(e) {
            var variant_id = $(this).closest(".cart__qty").find(".cart__qty-input").data("id");
            
            var $qty = $( this ).closest( '.cart__qty' ).find( '.cart__qty-input'),
                currentVal = parseFloat( $qty.val() ),
                max = parseFloat( $qty.attr( 'max' ) ),
                min = parseFloat( $qty.attr( 'min' ) ),
                step = $qty.attr( 'step' );

            var newQty = 0;

            if (! currentVal || currentVal === '' || currentVal === 'NaN') currentVal = 0;
            if (max === '' || max === 'NaN') max = '';
            if (min === '' || min === 'NaN') min = 0;
            if (step === 'any' || step === '' || step === undefined || parseFloat(step) === 'NaN') step = 1;
            
            if ($(this).is( '.plus')) {
              if ( max && (currentVal >= max)) {
                $qty.val( max );
              } else {
                $qty.val((currentVal + parseFloat(step)));
                newQty = currentVal + parseFloat(step);
              }
            } else {
              if ( min && ( currentVal <= min ) ) {
                $qty.val( min );
              } else if (currentVal > 0) {
                $qty.val((currentVal - parseFloat( step )));
                newQty = currentVal - parseFloat(step);
              }
            }
            
            if (!newQty == 0 ) {
              $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: 'quantity='+newQty+'&id='+variant_id,
                dataType: 'json',
                success:function(cart) {
                  nuranium.doUpdateMiniCart(cart, variant_id);
                },
                complete: function() {
                }
              }).done(function() {
  
              });
            }
            
            //$qty.trigger( 'change' );
          });
          
          $( document ).on( 'click', '.quick_view-qty-plus, .quick_view-qty-minus', function() {
            var $qty = $(this).closest( '.quick_view_qty' ).find( 'input[name="quantity"]'),
                currentVal = parseFloat($qty.val()),
                max = parseFloat($qty.attr('max')),
                min = parseFloat($qty.attr('min')),
                step = $qty.attr('step');

            if (!currentVal || currentVal === '' || currentVal === 'NaN') currentVal = 0;
            if (max === '' || max === 'NaN') max = '';
            if (min === '' || min === 'NaN') min = 0;
            if (step === 'any' || step === '' || step === undefined || parseFloat(step) === 'NaN') step = 1;

            if ($(this).is( '.quick_view-qty-plus')) {
              if ( max && (currentVal >= max)) {
                $qty.val( max );
              } else {
                $qty.val((currentVal + parseFloat(step)));
              }
            } else {
              if ( min && ( currentVal <= min ) ) {
                $qty.val( min );
              } else if (currentVal > 0) {
                $qty.val((currentVal - parseFloat( step )));
              }
            }
          });
        }
    }
})(jQuery);